import { render, staticRenderFns } from "./CommandForm.vue?vue&type=template&id=66b692b2&"
import script from "./CommandForm.vue?vue&type=script&lang=js&"
export * from "./CommandForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports